import {
  CLEAR_FILTERS,
  CHANGE_PAGE,
  CHANGE_SEARCH_TEXT,
  CHANGE_EVENT_TYPE_FILTER,
  CHANGE_STATUS_FILTER,
  CHANGE_MIN_DATE_FILTER,
  CHANGE_MAX_DATE_FILTER
} from '../actions/query';

export default function(state = {}, action) {
  switch (action.type) {
  case CHANGE_PAGE:
    return {
      ...state,
      page: action.page
    };
  case CHANGE_SEARCH_TEXT:
    return {
      ...state,
      searchText: action.value,
      page: 1
    };
  case CHANGE_EVENT_TYPE_FILTER:
    return {
      ...state,
      eventTypeFilter: action.eventTypeFilter,
      page: 1
    };
  case CHANGE_STATUS_FILTER:
    return {
      ...state,
      statusFilter: action.statusFilter,
      page: 1
    };
  case CHANGE_MIN_DATE_FILTER:
    return {
      ...state,
      minDate: action.minDateFilter,
      page: 1
    };
  case CHANGE_MAX_DATE_FILTER:
    return {
      ...state,
      maxDate: action.maxDateFilter,
      page: 1
    };
  case CLEAR_FILTERS:
    return {
      ...state,
      maxDate: null,
      minDate: null,
      searchText: '',
      eventTypeFilter: [],
      statusFilter: [],
      page: 1
    };
  default:
    return state;
  }
}
